import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { Root, Header, Subtitle, Title } from "./ModalEntry.style";

import Modal from "../../Modal/Modal";

export const ModalEntry = ({ onClose }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src =
      "https://app.viralsweep.com/vsa-widget-703a81-200333.js?sid=200333_872016";
    script.id = "viralsweep-script";

    const vsscript_200333_872016 = document.getElementById(
      "vsscript_200333_872016",
    );
    vsscript_200333_872016?.appendChild(script);
    vsscript_200333_872016.innerHTML = "";

    return () => {
      document.getElementById("viralsweep-script")?.remove();
      vsscript_200333_872016.innerHTML = "Loading...";
    };
  }, []);

  return (
    <Modal
      onClose={onClose}
      closeOnEsc
      closeOffset="16px"
      closeIconSize="24px"
      customClose={
        <svg
          viewBox="0 0 195 195"
          width="1em"
          height="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeWidth="15"
            d="M8 186 186 8M8 8l179 179"
            stroke="#6D5932"
            fill="none"
          />
        </svg>
      }
      maxWidth="800px"
    >
      <Root>
        <Header>
          <Subtitle>OFFICIAL ENTRY FORM</Subtitle>
          <Title>National moonshine week</Title>
        </Header>

        <div id="vsscript_200333_872016">Loading...</div>
      </Root>
    </Modal>
  );
};

ModalEntry.propTypes = {
  onClose: PropTypes.func,
};

ModalEntry.defaultProps = {
  onClose: null,
};
